const mutations = {

  getArticles: (state, articles) => {
    state.articles = articles;
  },
  getArticles2: (state, articles) => {
    state.articles = articles;
  },
  getCountHighlight: (state, counthighlight) => {
    state.counthighlight = counthighlight;
  },
  getDimension: (state, dimension) => {
    state.dimension = dimension;
  },
  getArticle: (state, article_id) => {
    state.article_id = article_id;
  },
  getAdminhub: (state, Adminhub) => {
    state.Adminhub = Adminhub;
  },
  getPackageSize: (state, PackageSize) => {
    state.PackageSize = PackageSize;
  },
  getItemtype: (state, Itemtype) => {
    state.Itemtype = Itemtype;
  },
  getAddon: (state, Addon) => {
    state.Addon = Addon;
  },
  getExtraPackaging: (state, ExtraPackaging) => {
    state.ExtraPackaging = ExtraPackaging;
  },
  postArticles: (state, new_articles) => {
    state.articles.push(new_articles);
  },
  updateStatusArticles: (state, new_status) => {
    state.articles = state.articles.map((articles) => {
      if (articles.id === new_status.articleid) {
        return Object.assign({}, articles, new_status.status);
      }
      return articles;
    });
  },
  putArticles: (state, payload) => {
    state.articles = state.articles.map((articles) => {
      if (articles.id === payload.id) {
        return Object.assign({}, articles, payload.formData);
      }
      return articles;
    });
  },
  delArticle(state, id) {
    const index = state.articles.findIndex(articles => articles.id == id);
    state.articles.splice(index, 1);
  },

};

export default mutations;
